// extracted by mini-css-extract-plugin
export default {"IframePageContent":"IframePage_IframePageContent__CruVu","IframePage":"IframePage_IframePage__YNQoJ","Iframe":"IframePage_Iframe__vexII"};